import React from "react";

function HeartIcon() {
  return (
    <span className="anticon ant-heart">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 16 15"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M7.941 14.344l-.56-.453c-3.349-2.705-5.37-4.335-6.52-6.464C.013 5.864-.213 4.323.203 2.97A4.204 4.204 0 012.421.405 4.082 4.082 0 014.219 0c1.518 0 2.947.792 3.722 2.02C8.717.792 10.147 0 11.663 0a4.209 4.209 0 014.017 2.97c.416 1.353.188 2.894-.658 4.457-1.151 2.13-3.175 3.763-6.527 6.47l-.554.447z"
        ></path>
      </svg>
    </span>
  );
}

export default HeartIcon;
